// Helpers de presentación. El TemplateEngine no ejecuta funciones dentro del HTML:
// todo lo que se muestra formateado se arma acá y se pasa ya listo al template.

const MONEDA = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/** 89066 → "$ 89.066" */
export const moneda = (valor) => {
  if (valor === null || valor === undefined || valor === "") return "—";
  return MONEDA.format(Number(valor)).replace("$", "$ ");
};

/**
 * "2026-08-06" → "06/08/2026".
 * Se parsea a mano y no con new Date(iso): el constructor interpreta el ISO corto como UTC
 * y en Argentina (UTC-3) devolvería el día anterior.
 */
export const fecha = (iso) => {
  if (!iso) return "—";
  const [anio, mes, dia] = String(iso).slice(0, 10).split("-");
  if (!anio || !mes || !dia) return "—";
  return dia + "/" + mes + "/" + anio;
};

/** Date local (sin corrimiento de zona) a partir de un ISO corto. */
export const aDate = (iso) => {
  if (!iso) return null;
  const [anio, mes, dia] = String(iso).slice(0, 10).split("-").map(Number);
  if (!anio || !mes || !dia) return null;
  return new Date(anio, mes - 1, dia);
};

/** Días desde hoy hasta la fecha dada (negativo si ya pasó). */
export const diasHasta = (iso) => {
  const destino = aDate(iso);
  if (!destino) return null;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return Math.round((destino - hoy) / 86400000);
};

/** "Vence en 23 días" / "Vencida hace 12 días" / "Vence hoy" */
export const textoVencimiento = (iso) => {
  const dias = diasHasta(iso);
  if (dias === null) return "";
  if (dias === 0) return "Vence hoy";
  if (dias > 0) return "Vence en " + dias + (dias === 1 ? " día" : " días");
  const pasados = Math.abs(dias);
  return "Vencida hace " + pasados + (pasados === 1 ? " día" : " días");
};

/** Escape para el HTML que se arma fuera del TemplateEngine (SweetAlert2, innerHTML manual). */
export const esc = (valor) => {
  if (valor === null || valor === undefined) return "";
  return String(valor)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

/** "ariel matias" → "Ariel Matias" (solo para textos que llegan en mayúsculas de la API). */
export const capitalizar = (texto) => {
  if (!texto) return "";
  return String(texto)
    .toLowerCase()
    .replace(/(^|\s)\p{L}/gu, (m) => m.toUpperCase());
};
